<template>
  <ValidationProvider :name="label" :rules="rules" v-slot="{ errors }">
    <v-file-input
      chips
      show-size
      :label="label"
      v-model="innerValue"
      truncate-length="10"
      :accept="accept"
      v-bind="$attrs"
      v-on="$listeners"
      @change="selectFile"
      :error-messages="errors"
    >
    </v-file-input>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationProvider,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    rules: {
      type: [Object, String],
      default: "",
    },
    value: null,
    accept: {
      type: String,
      default: "", // ex."image/*"
    },
  },
  data() {
    return {
      innerValue: null,
      selectedFile: null,
    };
  },
  methods: {
    selectFile() {
      this.selectedFile = event.target.files;
    },
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
    selectedFile(newVal) {
      this.$emit("select", newVal);
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>

<style lang="scss" scoped></style>
